import { TrackingUtils, UrlUtils } from "../../../../utils";

import { Item } from "../../../../components/Menu";
import React from "react";
import { links } from "./Config.resource";

const items = {
  siCom: new Item({
    URL: UrlUtils.getNativeLink(links.siCom),
    title: "SI.com",
    label: "si-com",
    target: "_blank"
  }),
  siShop: new Item({
    URL: UrlUtils.getNativeLink(links.siShop),
    title: "SI Shop",
    label: "si-shop",
    target: "_blank"
  }),
  siTickets: new Item({
    URL: UrlUtils.getNativeLink(links.siTickets),
    title: "SI Tickets",
    label: "si-tickets",
    target: "_blank"
  })
};

const handleSILinksClick = label => {
  TrackingUtils.sendAnalytics({
    dataCategory: "Menu",
    dataAction: "click",
    dataLabel: label,
    dataValue: ""
  });
};

const SILinksLayout = () => {
  return (
    <div className="SiLinksGroupPC">
      <a
        href={items.siCom.URL}
        target={items.siCom.target}
        onClick={() => handleSILinksClick(items.siCom.label)}
      >
        {items.siCom.title}
      </a>
      <a
        href={items.siShop.URL}
        target={items.siShop.target}
        onClick={() => handleSILinksClick(items.siShop.label)}
      >
        {items.siShop.title}
      </a>
      <a
        href={items.siTickets.URL}
        target={items.siTickets.target}
        onClick={() => handleSILinksClick(items.siTickets.label)}
      >
        {items.siTickets.title}
      </a>
    </div>
  );
};

export default React.memo(SILinksLayout);
